module.exports = __webpack_public_path__ + "static/media/42x38-1.2ba04109.png";